import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectCollectionPointsListItems } from "../../../../../../redux/collection-points/selector";
import { collectionPoints } from "../../../../../../redux/collection-points/action";

const ManagementCollectionPoints = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const CollectionPointItems = useSelector(selectCollectionPointsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'CollectionPointInfo.Name', headerName: 'Name' },
      { field: 'CollectionPointInfo.PhoneNumber', headerName: 'Phone Number' },
      { field: 'CollectionPointInfo.CountryCode', headerName: 'Country' },
      { field: 'CollectionPointInfo.SslEnabled', headerName: 'SslEnabled', cellRenderer: 'yesNoRenderer' },
      { field: 'CollectionPointInfo.IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
      
        ]);
      }
    
      const fetchCollectionPoint=()=>{

        dispatch(collectionPoints.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/collection-points/list`,entity:'collectionPoints',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchCollectionPoint()
	}, [pageData])
  const additionButtons: any = [
    {
      name: 'Add Collection Points',
      callback: () => handleAdd(),
    },
    {
      name:'Go to  Warehouse',
      callback: ()=> handleWarehouseClick()
    },
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleWarehouseClick=()=>{
    navigate('/management/organization/organization-management/ware-houses')
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.CollectionPointInfo?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(collectionPoints.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/collection-points/delete`,
      entity: 'collectionPoints',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(collectionPoints.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/collection-points/list`,entity:'collectionPoints',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {CollectionPointItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={CollectionPointItems?.result?.items} setPageData={setPageData} 
    onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Collection Points" />
     
  }
  </> 
	);
};

export default ManagementCollectionPoints;


